function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#E7C325;}\r\n\t.st1{fill:#96802F;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M148.3,40.8h15.6l11.3,45.6l12.6-45.6h12.1l12.6,45.6l11.3-45.6h15.6l-17.9,65.1h-16.9l-10.6-38.4l-10.6,38.4h-16.9 L148.3,40.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M240.1,73.4c0-19.2,15.2-33.8,33.8-33.8s33.8,14.7,33.8,33.8s-15.2,33.8-33.8,33.8S240.1,92.5,240.1,73.4z M293,73.4 c0-11.6-8.4-19.3-19-19.3s-19,7.7-19,19.3s8.4,19.3,19,19.3S293,85,293,73.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M338.2,84.5h-7.1v21.4h-14.9V40.8h26c12.4,0,22.3,9.9,22.3,22.3c0,8-4.8,15.2-12,18.9l13.9,23.9h-16L338.2,84.5z  M331.1,71.5h11.2c4.1,0,7.4-3.6,7.4-8.4c0-4.7-3.3-8.4-7.4-8.4h-11.2V71.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M411.5,91.6v14.3h-38.1V40.8h14.9v50.8H411.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.7,73.4c0,18.4-13.7,32.5-31.6,32.5h-26V40.8h26C462,40.8,475.7,55,475.7,73.4z M461.4,73.4 c0-11.2-7.1-18.2-17.3-18.2h-11.2v36.5h11.2C454.3,91.6,461.4,84.5,461.4,73.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M166.5,143.5v1.9h-15.2V119h15v1.9h-13v10.3h12.1v1.9h-12.1v10.5H166.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M207.9,132.2c0,7.3-5.2,13.2-12.4,13.2h-9.9V119h9.9C202.8,119,207.9,124.9,207.9,132.2z M206,132.2 c0-6.3-4.3-11.3-10.5-11.3h-7.9v22.6h7.9C201.7,143.5,206,138.5,206,132.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M227.4,136.6V119h2v17.6c0,4.3,2.7,7.3,7.7,7.3c5,0,7.7-3,7.7-7.3V119h2v17.6c0,5.6-3.9,9.2-9.7,9.2 C231.3,145.8,227.4,142.1,227.4,136.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M266.3,132.2c0-7.5,5.7-13.6,13.7-13.6c4.9,0,9.1,2.5,11.3,6.3l-1.8,1c-1.7-3.2-5.4-5.4-9.5-5.4 c-6.9,0-11.7,5.2-11.7,11.7s4.8,11.7,11.7,11.7c4.2,0,7.9-2.2,9.6-5.5l1.8,1c-2.1,3.9-6.4,6.4-11.4,6.4 C272,145.8,266.3,139.7,266.3,132.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M325.8,138.7h-13.2l-2.6,6.7h-2.1l10.3-26.4h2.1l10.2,26.4h-2.1L325.8,138.7z M325.1,136.8l-5.9-15.3l-5.9,15.3H325.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M362,120.9h-8.3v24.5h-2v-24.5h-8.3V119H362V120.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M382.6,119v26.4h-2V119H382.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M402.4,132.2c0-7.5,6-13.6,13.6-13.6s13.6,6.1,13.6,13.6s-6,13.6-13.6,13.6S402.4,139.7,402.4,132.2z M427.6,132.2 c0-6.5-5.1-11.7-11.6-11.7c-6.5,0-11.6,5.2-11.6,11.7s5.1,11.7,11.6,11.7C422.5,143.9,427.6,138.7,427.6,132.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M468.7,119v26.4H467l-15.6-22.7v22.7h-2V119h1.7l15.6,22.7V119H468.7z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.996 -8.990704e-002 8.990704e-002 0.996 -8.5605 2.5204)",
  className: "st0",
  cx: 23.7,
  cy: 96.3,
  rx: 0.7,
  ry: 2.3
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st0",
  cx: 30.1,
  cy: 91.6,
  rx: 1.2,
  ry: 2.3
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9956 9.378575e-002 -9.378575e-002 0.9956 8.2203 -3.3725)",
  className: "st0",
  cx: 40,
  cy: 85.8,
  rx: 1.5,
  ry: 2.3
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9726 0.2323 -0.2323 0.9726 19.7806 -9.7732)",
  className: "st0",
  cx: 51.4,
  cy: 79.1,
  rx: 1.6,
  ry: 2.1
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9862 0.1656 -0.1656 0.9862 12.7694 -9.3863)",
  className: "st0",
  cx: 62.7,
  cy: 71.9,
  rx: 1.6,
  ry: 2.1
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st0",
  cx: 72.4,
  cy: 64.7,
  rx: 1.5,
  ry: 1.6
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.866 -0.5 0.5 0.866 -17.9653 47.4921)",
  className: "st0",
  cx: 79.6,
  cy: 57.3,
  rx: 1.3,
  ry: 1.8
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -11.404 73.789)",
  className: "st0",
  cx: 83.4,
  cy: 50.7,
  rx: 1,
  ry: 1.8
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.866 0.5 -0.5 0.866 33.8279 -35.2377)",
  className: "st0",
  cx: 82.7,
  cy: 45.5,
  rx: 1.9,
  ry: 0.7
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9934 0.115 -0.115 0.9934 5.3671 -8.7064)",
  className: "st0",
  cx: 78.1,
  cy: 42.2,
  rx: 1.6,
  ry: 0.4
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9832 0.1826 -0.1826 0.9832 9.1299 -14.7882)",
  className: "st0",
  cx: 84.9,
  cy: 42.2,
  rx: 3.2,
  ry: 0.4
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9181 0.3964 -0.3964 0.9181 25.6554 -32.3859)",
  className: "st0",
  cx: 91.2,
  cy: 45.9,
  rx: 3,
  ry: 0.6
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.8141 0.5808 -0.5808 0.8141 47.5663 -45.3123)",
  className: "st0",
  cx: 94.6,
  cy: 51.6,
  rx: 3,
  ry: 1.1
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.8141 0.5808 -0.5808 0.8141 49.3461 -51.0136)",
  className: "st0",
  cx: 104.3,
  cy: 51.6,
  rx: 4,
  ry: 0.9
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 73.1407 -58.1005)",
  className: "st0",
  cx: 106.7,
  cy: 59.2,
  rx: 4.1,
  ry: 1.6
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.575 0.8182 -0.8182 0.575 100.5508 -57.0562)",
  className: "st0",
  cx: 105.2,
  cy: 68.2,
  rx: 4.1,
  ry: 2.5
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.4227 0.9062 -0.9062 0.4227 128.2271 -44.7979)",
  className: "st0",
  cx: 99.3,
  cy: 78.3,
  rx: 4.1,
  ry: 3.2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(8.472023e-002 0.9964 -0.9964 8.472023e-002 169.9402 -7.8829)",
  className: "st0",
  cx: 89.3,
  cy: 88.6,
  rx: 4.2,
  ry: 3.8
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(8.472023e-002 0.9964 -0.9964 8.472023e-002 168.523 13.0122)",
  className: "st0",
  cx: 77.2,
  cy: 98.2,
  rx: 4.4,
  ry: 4
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(8.472023e-002 0.9964 -0.9964 8.472023e-002 165.8043 33.9835)",
  className: "st0",
  cx: 64.4,
  cy: 107.2,
  rx: 4.4,
  ry: 4
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.5491 0.8358 -0.8358 0.5491 119.7257 8.1206)",
  className: "st0",
  cx: 52.3,
  cy: 115,
  rx: 4.4,
  ry: 3.3
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6147 0.7887 -0.7887 0.6147 111.942 12.8938)",
  className: "st0",
  cx: 42.8,
  cy: 121,
  rx: 4.2,
  ry: 2.6
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6147 0.7887 -0.7887 0.6147 113.3168 19.4189)",
  className: "st0",
  cx: 36.8,
  cy: 125.7,
  rx: 4.2,
  ry: 1.5
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.778 0.6283 -0.6283 0.778 96.2751 0.4102)",
  className: "st0",
  cx: 47.6,
  cy: 136.4,
  rx: 4.2,
  ry: 1.5
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.778 0.6283 -0.6283 0.778 95.1785 -3.8522)",
  className: "st0",
  cx: 53,
  cy: 132.7,
  rx: 4.2,
  ry: 2.3
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.778 0.6283 -0.6283 0.778 93.737 -10.6311)",
  className: "st0",
  cx: 61.9,
  cy: 127.3,
  rx: 4.2,
  ry: 3.3
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9458 0.3247 -0.3247 0.9458 48.254 -15.6896)",
  className: "st0",
  cx: 71.1,
  cy: 136.7,
  rx: 4.4,
  ry: 3.2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9172 0.3985 -0.3985 0.9172 61.472 -13.5059)",
  className: "st0",
  cx: 63.2,
  cy: 141.1,
  rx: 4.4,
  ry: 2.1
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9736 0.2282 -0.2282 0.9736 35.2726 -12.5799)",
  className: "st0",
  cx: 72,
  cy: 146.3,
  rx: 3.4,
  ry: 1.4
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9924 -0.1233 0.1233 0.9924 -17.4699 11.4146)",
  className: "st0",
  cx: 83.5,
  cy: 146.9,
  rx: 2.9,
  ry: 1.1
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9157 -0.4019 0.4019 0.9157 -50.0442 48.8838)",
  className: "st0",
  cx: 91.5,
  cy: 143.7,
  rx: 4.1,
  ry: 1.7
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.8332 -0.5529 0.5529 0.8332 -59.6752 79.3028)",
  className: "st0",
  cx: 101.6,
  cy: 138.6,
  rx: 5.3,
  ry: 1.9
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6737 -0.739 0.739 0.6737 -60.3711 125.8328)",
  className: "st0",
  cx: 112.3,
  cy: 131.3,
  rx: 5.9,
  ry: 1.7
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.5 -0.866 0.866 0.5 -45.1291 166.1589)",
  className: "st0",
  cx: 121.3,
  cy: 122.2,
  rx: 5.9,
  ry: 1.4
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st0",
  cx: 78,
  cy: 148.4,
  rx: 2.3,
  ry: 0.3
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st0",
  cx: 78.6,
  cy: 143.4,
  rx: 4,
  ry: 2.3
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9312 -0.3644 0.3644 0.9312 -44.4268 41.7246)",
  className: "st0",
  cx: 88.3,
  cy: 138.6,
  rx: 4.8,
  ry: 3.1
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.8134 -0.5817 0.5817 0.8134 -57.9984 82.7369)",
  className: "st0",
  cx: 100,
  cy: 131.8,
  rx: 5.5,
  ry: 3.3
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.563 -0.8265 0.8265 0.563 -52.7089 146.0374)",
  className: "st0",
  cx: 111.7,
  cy: 122.9,
  rx: 5.8,
  ry: 3.3
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.3361 -0.9418 0.9418 0.3361 -25.3014 189.2258)",
  className: "st0",
  cx: 121.6,
  cy: 112.6,
  rx: 6,
  ry: 2.7
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(9.379374e-002 -0.9956 0.9956 9.379374e-002 15.6303 219.073)",
  className: "st0",
  cx: 128.2,
  cy: 101,
  rx: 6.1,
  ry: 1.6
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9022 0.4314 -0.4314 0.9022 67.8004 -11.4096)",
  className: "st0",
  cx: 59.1,
  cy: 143.8,
  rx: 4.4,
  ry: 0.9
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.866 0.5 -0.5 0.866 69.9391 -20.6255)",
  className: "st0",
  cx: 73.5,
  cy: 120.2,
  rx: 4.4,
  ry: 4.2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.866 0.5 -0.5 0.866 67.2616 -28.3153)",
  className: "st0",
  cx: 86.5,
  cy: 111.4,
  rx: 4.8,
  ry: 4.7
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st0",
  cx: 99,
  cy: 101.1,
  rx: 4.7,
  ry: 4.8
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(8.472023e-002 0.9964 -0.9964 8.472023e-002 189.5537 -26.754)",
  className: "st0",
  cx: 109.3,
  cy: 89.8,
  rx: 4.8,
  ry: 3.8
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.3797 0.9251 -0.9251 0.3797 144.6062 -58.3627)",
  className: "st0",
  cx: 115.8,
  cy: 78.6,
  rx: 4.8,
  ry: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(8.472023e-002 0.9964 -0.9964 8.472023e-002 202.5419 -41.431)",
  className: "st0",
  cx: 123.8,
  cy: 89.5,
  rx: 5.7,
  ry: 2.6
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(-0.1815 0.9834 -0.9834 -0.1815 238.3675 4.5905)",
  className: "st0",
  cx: 117.3,
  cy: 101.5,
  rx: 5.7,
  ry: 3.6
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(-0.6205 0.7842 -0.7842 -0.6205 261.8557 98.679)",
  className: "st0",
  cx: 107.1,
  cy: 112.7,
  rx: 5.7,
  ry: 4.3
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(-0.7515 0.6597 -0.6597 -0.7515 246.3743 152.1783)",
  className: "st0",
  cx: 94.5,
  cy: 122.5,
  rx: 5.5,
  ry: 4.2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(-0.9312 0.3644 -0.3644 -0.9312 205.7357 222.7051)",
  className: "st0",
  cx: 81.9,
  cy: 130.8,
  rx: 4.8,
  ry: 3.9
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.5 0.866 -0.866 0.5 118.0274 -67.9309)",
  className: "st0",
  cx: 117.8,
  cy: 68.2,
  rx: 4.8,
  ry: 2.1
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.3097 0.9508 -0.9508 0.3097 161.341 -65.9176)",
  className: "st0",
  cx: 126.1,
  cy: 78.2,
  rx: 5.5,
  ry: 1.8
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6684 0.7438 -0.7438 0.6684 82.1065 -66.5465)",
  className: "st0",
  cx: 115.7,
  cy: 58.8,
  rx: 4.8,
  ry: 1.1
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6684 0.7438 -0.7438 0.6684 74.8717 -50.3194)",
  className: "st0",
  cx: 93.9,
  cy: 58.8,
  rx: 3,
  ry: 1.6
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.5408 0.8412 -0.8412 0.5408 97.379 -43.6966)",
  className: "st0",
  cx: 88.7,
  cy: 67.3,
  rx: 3,
  ry: 2.3
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2333 0.9724 -0.9724 0.2333 135.217 -19.3244)",
  className: "st0",
  cx: 79.9,
  cy: 76.1,
  rx: 3,
  ry: 2.7
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(3.499746e-002 0.9994 -0.9994 3.499746e-002 150.9663 12.9715)",
  className: "st0",
  cx: 68.8,
  cy: 84.7,
  rx: 3,
  ry: 2.7
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(3.499746e-002 0.9994 -0.9994 3.499746e-002 147.2731 33.3923)",
  className: "st0",
  cx: 56.3,
  cy: 93,
  rx: 3,
  ry: 2.7
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(3.499746e-002 0.9994 -0.9994 3.499746e-002 143.3526 52.3254)",
  className: "st0",
  cx: 44.6,
  cy: 100.4,
  rx: 3.1,
  ry: 2.4
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2828 0.9592 -0.9592 0.2828 127.4552 43.4807)",
  className: "st0",
  cx: 34.7,
  cy: 107,
  rx: 3.3,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.3277 0.9448 -0.9448 0.3277 124.9678 48.6568)",
  className: "st0",
  cx: 28.3,
  cy: 112.1,
  rx: 3.3,
  ry: 1.5
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.4114 0.9115 -0.9115 0.4114 121.6033 44.2629)",
  className: "st0",
  cx: 26.5,
  cy: 116.3,
  rx: 3.3,
  ry: 0.5
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9321 0.3621 -0.3621 0.9321 23.1544 -32.5006)",
  className: "st0",
  cx: 98.3,
  cy: 45.5,
  rx: 4.1,
  ry: 0.6
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9832 0.1826 -0.1826 0.9832 9.1116 -15.7475)",
  className: "st0",
  cx: 90.1,
  cy: 41.6,
  rx: 3.8,
  ry: 0.4
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M24.6,163.6c0-3.6,2.7-6.6,6.6-6.6c2.3,0,4.4,1.2,5.5,3.1l-0.9,0.5c-0.8-1.6-2.6-2.6-4.6-2.6 c-3.3,0-5.7,2.5-5.7,5.6s2.3,5.6,5.7,5.6c2,0,3.8-1.1,4.6-2.7l0.9,0.5c-1,1.9-3.1,3.1-5.5,3.1C27.3,170.2,24.6,167.2,24.6,163.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M44.3,165.4c0-2.7,2.1-4.8,4.8-4.8c2.6,0,4.8,2.1,4.8,4.8s-2.1,4.8-4.8,4.8C46.4,170.2,44.3,168.1,44.3,165.4 z M52.9,165.4c0-2.2-1.7-3.9-3.8-3.9c-2.2,0-3.9,1.7-3.9,3.9s1.7,3.9,3.9,3.9C51.3,169.3,52.9,167.6,52.9,165.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M62.2,156.7h0.9V170h-0.9V156.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M71.9,156.7h0.9V170h-0.9V156.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M90.7,160.9v9.1h-0.9v-2.1c-0.8,1.4-2.2,2.3-3.9,2.3c-2.6,0-4.7-2.1-4.7-4.8s2.1-4.8,4.7-4.8 c1.7,0,3.1,0.9,3.9,2.3v-2.1H90.7z M89.8,165.4c0-2.2-1.7-3.9-3.8-3.9c-2.2,0-3.9,1.7-3.9,3.9s1.7,3.9,3.9,3.9 C88.1,169.3,89.8,167.6,89.8,165.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M109.2,165.4c0,2.7-2.1,4.8-4.7,4.8c-1.8,0-3.2-0.9-3.9-2.3v2.1h-0.9v-12.7h0.9v5.8c0.7-1.4,2.1-2.3,3.9-2.3 C107.1,160.7,109.2,162.7,109.2,165.4z M108.3,165.4c0-2.2-1.7-3.9-3.9-3.9c-2.2,0-3.9,1.7-3.9,3.9s1.7,3.9,3.9,3.9 C106.6,169.3,108.3,167.6,108.3,165.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M116.9,165.4c0-2.7,2.1-4.8,4.8-4.8c2.6,0,4.8,2.1,4.8,4.8s-2.1,4.8-4.8,4.8 C119.1,170.2,116.9,168.1,116.9,165.4z M125.6,165.4c0-2.2-1.7-3.9-3.8-3.9c-2.2,0-3.9,1.7-3.9,3.9s1.7,3.9,3.9,3.9 C123.9,169.3,125.6,167.6,125.6,165.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M138.8,160.7v0.9c-1.6,0-3,1-3,3.3v5.1h-0.9v-9.1h0.9v1.8C136.3,161.2,137.5,160.7,138.8,160.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M155.1,160.9v9.1h-0.9v-2.1c-0.8,1.4-2.2,2.3-3.9,2.3c-2.6,0-4.7-2.1-4.7-4.8s2.1-4.8,4.7-4.8 c1.7,0,3.1,0.9,3.9,2.3v-2.1H155.1z M154.1,165.4c0-2.2-1.7-3.9-3.8-3.9c-2.2,0-3.9,1.7-3.9,3.9s1.7,3.9,3.9,3.9 C152.5,169.3,154.1,167.6,154.1,165.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M165.8,161.8v5.9c0,1.6,0.9,1.6,2.7,1.5v0.8c-2.4,0.4-3.6-0.2-3.6-2.3v-5.9h-2v-0.9h2v-2.3l0.9-0.3v2.5h2.7 v0.9H165.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M184.8,165.5c0,0.1,0,0.3,0,0.4h-8.2c0.2,2.1,1.8,3.4,3.9,3.4c1.5,0,2.6-0.7,3.1-1.7l0.8,0.5 c-0.7,1.2-2.2,2.1-4,2.1c-2.8,0-4.8-2-4.8-4.8c0-2.7,1.9-4.8,4.7-4.8C183,160.7,184.8,163,184.8,165.5z M176.5,165h7.3 c-0.2-2.2-1.8-3.5-3.5-3.5C178.2,161.5,176.7,163,176.5,165z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M192.5,169.3c0-0.5,0.3-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8s-0.4,0.8-0.8,0.8 C192.9,170.1,192.5,169.8,192.5,169.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M215,157.2V170h-1v-12.7H215z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M231.8,164.3v5.7h-0.9v-5.7c0-1.7-1-2.8-2.7-2.8c-1.8,0-3.2,1.2-3.2,3.6v4.8h-0.9v-9.1h0.9v1.7 c0.7-1.3,1.9-1.9,3.3-1.9C230.5,160.7,231.8,162.1,231.8,164.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M248.3,164.3v5.7h-0.9v-5.7c0-1.7-1-2.8-2.7-2.8c-1.8,0-3.2,1.2-3.2,3.6v4.8h-0.9v-9.1h0.9v1.7 c0.7-1.3,1.9-1.9,3.3-1.9C246.9,160.7,248.3,162.1,248.3,164.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M256.4,165.4c0-2.7,2.1-4.8,4.8-4.8c2.6,0,4.8,2.1,4.8,4.8s-2.1,4.8-4.8,4.8 C258.6,170.2,256.4,168.1,256.4,165.4z M265.1,165.4c0-2.2-1.7-3.9-3.8-3.9s-3.9,1.7-3.9,3.9s1.7,3.9,3.9,3.9 S265.1,167.6,265.1,165.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M281.6,160.9l-3.8,9.1h-1.1l-3.9-9.1h1l3.4,8.2l3.4-8.2H281.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M297.9,160.9v9.1H297v-2.1c-0.8,1.4-2.2,2.3-3.9,2.3c-2.6,0-4.7-2.1-4.7-4.8s2.1-4.8,4.7-4.8 c1.7,0,3.1,0.9,3.9,2.3v-2.1H297.9z M297,165.4c0-2.2-1.7-3.9-3.8-3.9s-3.9,1.7-3.9,3.9s1.7,3.9,3.9,3.9S297,167.6,297,165.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M308.7,161.8v5.9c0,1.6,0.9,1.6,2.7,1.5v0.8c-2.4,0.4-3.6-0.2-3.6-2.3v-5.9h-2v-0.9h2v-2.3l0.9-0.3v2.5h2.7 v0.9H308.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M327.6,165.5c0,0.1,0,0.3,0,0.4h-8.2c0.2,2.1,1.8,3.4,3.9,3.4c1.5,0,2.6-0.7,3.1-1.7l0.8,0.5 c-0.7,1.2-2.2,2.1-4,2.1c-2.8,0-4.8-2-4.8-4.8c0-2.7,1.9-4.8,4.7-4.8C325.9,160.7,327.6,163,327.6,165.5z M319.3,165h7.3 c-0.2-2.2-1.8-3.5-3.5-3.5C321,161.5,319.5,163,319.3,165z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M335.3,169.3c0-0.5,0.3-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8s-0.4,0.8-0.8,0.8 C335.7,170.1,335.3,169.8,335.3,169.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M364.2,169.1v0.9h-7.3v-12.7h7.2v0.9h-6.3v5h5.8v0.9h-5.8v5.1H364.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M381.2,157.2V170h-0.9v-2.1c-0.7,1.4-2.1,2.3-3.9,2.3c-2.6,0-4.7-2.1-4.7-4.8s2.1-4.8,4.7-4.8 c1.8,0,3.2,0.9,3.9,2.3v-5.8H381.2z M380.3,165.4c0-2.2-1.7-3.9-3.9-3.9s-3.9,1.7-3.9,3.9s1.7,3.9,3.9,3.9 S380.3,167.6,380.3,165.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M397.6,160.9v9.1h-0.9v-1.7c-0.7,1.3-1.9,1.9-3.3,1.9c-2.2,0-3.5-1.4-3.5-3.6v-5.7h0.9v5.7 c0,1.7,1,2.8,2.7,2.8c1.8,0,3.2-1.2,3.2-3.6v-4.8H397.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M406,165.4c0-2.7,2-4.8,4.8-4.8c1.8,0,3.3,0.9,4,2.3l-0.7,0.4c-0.5-1.1-1.8-1.9-3.2-1.9 c-2.2,0-3.9,1.7-3.9,3.9s1.7,3.9,3.9,3.9c1.5,0,2.7-0.8,3.3-1.9l0.8,0.5c-0.7,1.4-2.3,2.3-4,2.3C408,170.2,406,168.1,406,165.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M431.8,160.9v9.1h-0.9v-2.1c-0.8,1.4-2.2,2.3-3.9,2.3c-2.6,0-4.7-2.1-4.7-4.8s2.1-4.8,4.7-4.8 c1.7,0,3.1,0.9,3.9,2.3v-2.1H431.8z M430.8,165.4c0-2.2-1.7-3.9-3.8-3.9s-3.9,1.7-3.9,3.9s1.7,3.9,3.9,3.9 S430.8,167.6,430.8,165.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M442.5,161.8v5.9c0,1.6,0.9,1.6,2.7,1.5v0.8c-2.4,0.4-3.6-0.2-3.6-2.3v-5.9h-2v-0.9h2v-2.3l0.9-0.3v2.5h2.7 v0.9H442.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M461.5,165.5c0,0.1,0,0.3,0,0.4h-8.2c0.2,2.1,1.8,3.4,3.9,3.4c1.5,0,2.6-0.7,3.1-1.7l0.8,0.5 c-0.7,1.2-2.2,2.1-4,2.1c-2.8,0-4.8-2-4.8-4.8c0-2.7,1.9-4.8,4.7-4.8C459.7,160.7,461.5,163,461.5,165.5z M453.2,165h7.3 c-0.2-2.2-1.8-3.5-3.5-3.5C454.9,161.5,453.4,163,453.2,165z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M469.2,169.3c0-0.5,0.3-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8s-0.4,0.8-0.8,0.8 C469.5,170.1,469.2,169.8,469.2,169.3z"
})));

var SvgDarkLogo = function SvgDarkLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 504 216",
    style: {
      enableBackground: "new 0 0 504 216"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDarkLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dark_logo.bccb7d1e.svg";
export { ForwardRef as ReactComponent };